import { trackEvent, identifyUser } from '../components/analytics/analytics'
import { TRACK_EVENTS } from '../constants'
import { CSAT_PLATFORM } from './constants'

// app_version has no source in this repo yet (REACT_APP_VERSION is unset and react-scripts
// does not inline package.json's version). We attach it only when a build actually provides
// it, so the plumbing is correct the day ops wires the build arg and we never emit a placeholder.
const getAppVersion = () => process.env.REACT_APP_VERSION || undefined

// Always stamp platform + (when present) app_version, and drop empty values so events carry
// no null/'' noise.
const withBaseProperties = (properties = {}) => {
  const merged = { platform: CSAT_PLATFORM, app_version: getAppVersion(), ...properties }
  return Object.keys(merged).reduce((accumulator, key) => {
    const value = merged[key]
    if (value !== undefined && value !== null && value !== '') accumulator[key] = value
    return accumulator
  }, {})
}

export const trackCsatOpened = ({ tool, source }) => trackEvent(TRACK_EVENTS.CSAT_FORM_OPENED, withBaseProperties({ tool, source }))

export const trackCsatDismissed = ({ tool }) => trackEvent(TRACK_EVENTS.CSAT_FORM_DISMISSED, withBaseProperties({ tool }))

export const trackCsatSubmitted = ({ rating, tool, comment, contact }) =>
  trackEvent(TRACK_EVENTS.CSAT_FORM_SUBMITTED, withBaseProperties({ rating, tool, comment, contact }))

// Mirror the answered fact onto the Segment user profile so "already responded" can be read
// account-scoped (cross-device) without a backend. Optional layer; safe to remove.
export const identifyCsatResponse = (userId, { at, tool }) => {
  if (!userId) return
  identifyUser(userId, { csat_last_responded_at: at, csat_last_tool: tool })
}
